var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMotif01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 15.9953,
    viewBox: "0 0 16 15.9953",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 144"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 7.99767C0 12.4146 3.58176 15.9953 8 15.9953C12.4182 15.9953 16 12.4146 16 7.99767C16 3.58072 12.4182 0 8 0H0V7.99767Z",
    fill: "#86905B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M0 4.13681C0 6.42138 1.85261 8.27345 4.13801 8.27345C6.42325 8.27345 8.27586 6.42138 8.27586 4.13681C8.27586 1.85207 6.42325 0 4.13801 0H0V4.13681Z",
    fill: "#274766"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotif01);
export default __webpack_public_path__ + "static/media/motif-01.b45d49d73ccbd3b0c247d8b67f0bab33.svg";
export { ForwardRef as ReactComponent };